var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z",
    fill: "#C9A962",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 33.3333C42.6666 39.9999 37.9999 43.3333 32.4533 45.2666C32.1628 45.365 31.8473 45.3603 31.5599 45.2533C25.9999 43.3333 21.3333 39.9999 21.3333 33.3333V23.9999C21.3333 23.6463 21.4737 23.3072 21.7238 23.0571C21.9738 22.8071 22.313 22.6666 22.6666 22.6666C25.3333 22.6666 28.6666 21.0666 30.9866 19.0399C31.2691 18.7986 31.6284 18.666 31.9999 18.666C32.3714 18.666 32.7308 18.7986 33.0133 19.0399C35.3466 21.0799 38.6666 22.6666 41.3333 22.6666C41.6869 22.6666 42.026 22.8071 42.2761 23.0571C42.5261 23.3072 42.6666 23.6463 42.6666 23.9999V33.3333Z",
    stroke: "#C9A962",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea03);
export default __webpack_public_path__ + "static/media/area03.0adecaf12d6db048d801f1d783a3c2e6.svg";
export { ForwardRef as ReactComponent };